import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-form-package/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Form, Button, Field, Select, RadioGroup } from '../src';
import { Playground } from 'docz';
import { DynamicFieldsOnChange } from './components/DynamicFieldsOnChange';
import { DynamicFieldsOnClick } from './components/DynamicFieldsOnClick';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "dynamic-fields"
    }}>{`Dynamic Fields`}</h1>
    <p>{`Sometimes you do not know how many fields your form should have, so you need a way to add dynamic fields on user events, e.g. on a button click if a user should decide if a new field is needed, or on a change of a field, e.g. when a field is filled a new field should appear.`}</p>
    <h2 {...{
      "id": "onclick"
    }}>{`onClick`}</h2>
    <p>{`First off, import your components.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React from 'react';
import {
  Form,
  Field,
  Button,
} from 'react-form-package';
`}</code></pre>
    <p>{`The next step is to create a `}<inlineCode parentName="p">{`class`}</inlineCode>{` that will render our form.`}</p>
    <p>{`The state is allways handled by `}<inlineCode parentName="p">{`react-form-package`}</inlineCode>{`, the only thing that you need todo is to handle the appearence of the form, e.g. add or remove the input.`}</p>
    <p>{`We need create a `}<inlineCode parentName="p">{`addField`}</inlineCode>{`, `}<inlineCode parentName="p">{`removeField`}</inlineCode>{`, and optionally a `}<inlineCode parentName="p">{`calculateAvailableId`}</inlineCode>{` function. The `}<inlineCode parentName="p">{`calculateAvailableId`}</inlineCode>{` is only nessacary if you work on non unique index-based ids so that you ensure you do not overide an existing id.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`addField`}</inlineCode>{` function is here to add a new Field when you click on a `}<inlineCode parentName="p">{`<Button />`}</inlineCode>{` component.`}</p>
    <p>{`To update the state of the `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` component, you need to add a `}<inlineCode parentName="p">{`rfpRole`}</inlineCode>{` property and a `}<inlineCode parentName="p">{`field`}</inlineCode>{` or a `}<inlineCode parentName="p">{`fieldId`}</inlineCode>{` property to a `}<inlineCode parentName="p">{`<Button />`}</inlineCode>{` component.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`rfpRole`}</inlineCode>{` takes a string which is either `}<inlineCode parentName="p">{`addField`}</inlineCode>{` or `}<inlineCode parentName="p">{`removeField`}</inlineCode>{`. `}</p>
    <p>{`If you use the `}<inlineCode parentName="p">{`<Button />`}</inlineCode>{` component to add a new field to the state of the form component you need to provide a `}<inlineCode parentName="p">{`field`}</inlineCode>{` property which takes an object that represents your new `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` component. This object has to have at least a `}<inlineCode parentName="p">{`id`}</inlineCode>{` and a `}<inlineCode parentName="p">{`type`}</inlineCode>{`, but you can extend this object with rules like: `}<inlineCode parentName="p">{`min`}</inlineCode>{`, `}<inlineCode parentName="p">{`max`}</inlineCode>{`, `}<inlineCode parentName="p">{`required`}</inlineCode>{`, `}<inlineCode parentName="p">{`match`}</inlineCode>{`, and `}<inlineCode parentName="p">{`sameAs`}</inlineCode>{`.`}</p>
    <p>{`If you use the `}<inlineCode parentName="p">{`<Button />`}</inlineCode>{` component to add remove an existing field from the state of the form component you need to provide a `}<inlineCode parentName="p">{`fieldId`}</inlineCode>{` property which takes a string: the `}<inlineCode parentName="p">{`id`}</inlineCode>{` of the field you want to remove.`}</p>
    <p>{`In the state of the `}<inlineCode parentName="p">{`DynamicFields`}</inlineCode>{` component you have to create an array where you add refrences to the fields of your dynamic `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` components. To add new fields you need to add a new refrence, so that the part of the DOM rerenders with the new Field Component. To remove the Fields not only from the state of the `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` component but also from the DOM, you need to remove the refrences in your state that the component rerenders that part of the DOM.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`class DynamicFields extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // the field refrences that we use to render in our <Form /> component
      companies: [
        {
          id: 'company-0',
        },
      ],
    };

    this.addField = this.addField.bind(this);
    this.removeField = this.removeField.bind(this);
    this.calculateAvailableId = this.calculateAvailableId.bind(this);
  }

  calculateAvailableId() {
    const {
      companies,
    } = this.state;

    const arr = companies.map((item) => parseInt(item.id.split('-')[1], 10));

    let currentHighestId = Math.max(...arr);
    currentHighestId = currentHighestId !== -Infinity ? currentHighestId : 0;

    const highestAvailableId = currentHighestId + 1;

    return highestAvailableId;
  }

  addField() {
    const {
      companies,
    } = this.state;

    const highestAvailableId = this.calculateAvailableId();

    // add a new field refrence to the <Form /> component
    this.setState({
      companies: companies.concat({ id: \`company-\${highestAvailableId}\` }),
    });
  }

  removeField(idx) {
    const {
      companies,
    } = this.state;

    // remove a field refrence to the <Form /> component
    this.setState({
      companies: companies.filter((_, index) => idx !== index),
    });
  }

  render() {
    const {
      companies,
    } = this.state;

    const highestAvailableId = this.calculateAvailableId();

    return (
      <Form
        validate
      >
        {/* render the <Field /> components based on our field refrences */}
        {companies.map((company, idx) => (
          <div>
            <Field
              id={company.id}
              placeholder={\`Company \${company.id.split('-')[1]}\`}
              type="text"
              required
            />
            <Button
              id="removeField"
              // add the rfpRole property
              rfpRole="removeField"
              type="button"
              // add the fieldId property to remove the field from the state of the <Form /> component
              fieldId={company.id}
              onClick={() => this.removeField(idx)}
            >
              Remove Company
            </Button>
          </div>
        ))}
        <div>
          <Button
            id="addField"
            // add the rfpRole property
            rfpRole="addField"
            type="button"
            // add the field property to add to the state state of the <Form /> component
            field={{
              id: \`company-\${highestAvailableId}\`,
              type: 'text',
              required: true,
            }}
            onClick={() => this.addField()}
          >
            Add Company
          </Button>
        </div>
        <div>
          <Button
            id="submit"
            type="submit"
            onClick={(state) => {
              alert(JSON.stringify(state, null, 2));
              alert('open the console to see the whole state...');
              console.log(state);
            }}
          >
            submit
          </Button>
        </div>
      </Form>
    );
  }
}

export { DynamicFields };
`}</code></pre>
    <p>{`Now render this Component. Everytime you click on the button `}<inlineCode parentName="p">{`Add Company`}</inlineCode>{` you get a new field, and everytime you click on the button `}<inlineCode parentName="p">{`Remove Company`}</inlineCode>{` you remove the corresponding field.`}</p>
    <Playground __position={0} __code={'<DynamicFieldsOnClick />'} __scope={{
      props,
      DefaultLayout,
      Form,
      Button,
      Field,
      Select,
      RadioGroup,
      Playground,
      DynamicFieldsOnChange,
      DynamicFieldsOnClick
    }} mdxType="Playground">
  <DynamicFieldsOnClick mdxType="DynamicFieldsOnClick" />
    </Playground>
    <h2 {...{
      "id": "onchange"
    }}>{`onChange`}</h2>
    <p>{`First off, import your components.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React from 'react';
import {
  Form,
  Field,
  Button,
} from 'react-form-package';
`}</code></pre>
    <p>{`The next step is to create a `}<inlineCode parentName="p">{`class`}</inlineCode>{` that will render our form. `}</p>
    <p>{`Everything stays the same as in the example above, except:`}</p>
    <p>{`That we now use a `}<inlineCode parentName="p">{`dynamic`}</inlineCode>{` property and the `}<inlineCode parentName="p">{`field`}</inlineCode>{` property on the `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` component. the `}<inlineCode parentName="p">{`field`}</inlineCode>{` property takes the same properties as in the `}<inlineCode parentName="p">{`<Button />`}</inlineCode>{` component. The `}<inlineCode parentName="p">{`dynamic`}</inlineCode>{` property indicates that this `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` component is dynamic and adds a new field in the state of the `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` component when this `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` is filled.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`class DynamicFields extends React.Component {
  constructor(props) {
    super(props);

    // the field refrences that we use to render in our <Form /> component
    this.state = {
      companies: [
        {
          id: 'company-0',
        },
      ],
    };

    this.addField = this.addField.bind(this);
    this.removeField = this.removeField.bind(this);
    this.calculateAvailableId = this.calculateAvailableId.bind(this);
  }

  calculateAvailableId() {
    const {
      companies,
    } = this.state;

    const arr = companies.map((item) => parseInt(item.id.split('-')[1], 10));

    let currentHighestId = Math.max(...arr);
    currentHighestId = currentHighestId !== -Infinity ? currentHighestId : 0;

    const highestAvailableId = currentHighestId + 1;

    return highestAvailableId;
  }

  addField(state, id) {
    const {
      companies,
    } = this.state;

    const highestAvailableId = this.calculateAvailableId();

    // add a new field refrence to the <Form /> component
    if (state.data[id] && parseInt(id.split('-')[1], 10) + 1 === highestAvailableId) {
      this.setState({
        companies: companies.concat({ id: \`company-\${highestAvailableId}\` }),
      });
    }
  }

  removeField(idx) {
    const {
      companies,
    } = this.state;

    // remove a field refrence to the <Form /> component
    this.setState({
      companies: companies.filter((_, index) => idx !== index),
    });
  }

  render() {
    const {
      companies,
    } = this.state;

    const highestAvailableId = this.calculateAvailableId();

    return (
      <Form>
        {/* render the <Field /> components based on our field refrences */}
        {companies.map((company, idx) => (
          <div>
            <Field
              id={company.id}
              placeholder={\`Company \${company.id.split('-')[1]}\`}
              type="text"
              required
              // add the dynamic property 
              dynamic
              // add the field property to add to the state state of the <Form /> component
              field={{
                id: \`company-\${highestAvailableId}\`,
                type: 'text',
                required: true,
              }}
              onChange={(state) => this.addField(state, company.id)}
            />
            {companies.length && (
              <Button
                id="removeField"
                // add the rfpRole property
                rfpRole="removeField"
                type="button"
                // add the fieldId property to remove the field from the state of the <Form /> component
                fieldId={company.id}
                onClick={() => this.removeField(idx)}
              >
                Remove Company
              </Button>
            )}

          </div>
        ))}
        <div>
          <Button
            id="submit"
            type="submit"
            onClick={(state) => {
              alert(JSON.stringify(state, null, 2));
              alert('open the console to see the whole state...');
              console.log(state);
            }}
          >
            submit
          </Button>
        </div>
      </Form>
    );
  }
}

export { DynamicFieldsOnChange };
`}</code></pre>
    <p>{`Now render this Component. Everytime you fill out the `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` component you will add a new `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{`, and everytime you click on the button `}<inlineCode parentName="p">{`Remove Company`}</inlineCode>{` you remove the corresponding field.`}</p>
    <Playground __position={1} __code={'<DynamicFieldsOnChange />'} __scope={{
      props,
      DefaultLayout,
      Form,
      Button,
      Field,
      Select,
      RadioGroup,
      Playground,
      DynamicFieldsOnChange,
      DynamicFieldsOnClick
    }} mdxType="Playground">
  <DynamicFieldsOnChange mdxType="DynamicFieldsOnChange" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      